import { useState } from "react";
import { get, put, post } from "../api";
import { QueryClient, useQuery, useMutation } from "@tanstack/react-query";

const queryClient = new QueryClient();

const getImages = async () => await get("/images");
function useImages() {
  const [state, setState] = useState([]);
  const _imageQuery = useQuery({
    queryKey: ["images"],
    queryFn: getImages,
    onSuccess: (data) => setState(data),
  });

  const importImage = () => {};
  const deleteImage = (id) => {};
  return {
    importImage,
    deleteImage,
    state,
  };
}
export default useImages;
